import Konva from "konva";
import * as _ from 'lodash';
import { HGroup } from '../area/HGroup';
import { VGroup } from "../area/VGroup";
import { SC_Input } from '../input/SC_Input';
import { DrawRoofForPanel } from "../panel/drawRoofForPanel";
import { Dyn } from '../utilities/dyn';
import { Global } from "../utilities/global";
import { RoofItemType } from './roofItemType';
import { Sol50 } from './Sol50';
import { Sol50Integrated } from './Sol50Integrated';

export class SubFrameIn {
	static aVGroups: any = [];
	static drawFramework() {
		SubFrameIn.getGroups();
		SubFrameIn.drawEindeckblech();//left and right frames for integrated roof
		SubFrameIn.drawTopAbschlussblech();//top frame for integrated
		SubFrameIn.drawHProfil();
	}

	static getAllPanels(): any {
		let allPanels: any = DrawRoofForPanel.layerPanel.find("." + Global.panelsOnRoof);
		return allPanels.map((group: any) => {
			return group.getAttrs();
		});
	}
	static getGroups(): void {
		var aCol: any[];
		var vgroupTmp: VGroup;
		var i: number, j: number, iInvalid: number;
		var iCurrent: number, iCurrent2: number;
		var iLen: number, iLen2: number;
		// Global.hgroups.sortOn("x", Array.NUMERIC);
		// SubFrameIn.getAllPanels();
		Global.hgroups = _.sortBy(Global.hgroups, 'x');
		//sort array of arrays based on hgroup x axis values 
		Global.hgroups = Global.hgroups.sort(function(a:any, b:any) {
			return b[0].x - a[0].x;
		  });

		iCurrent = 0;
		iLen = Global.hgroups.length;
		// if (SubFrameIn.aVGroups.length > 0) {
		SubFrameIn.aVGroups = new Array();
		// }
		while (iCurrent < iLen) {
			aCol = SubFrameIn.getCol(Global.hgroups, iCurrent);
			iCurrent += aCol.length;
			// aCol.sortOn("y", Array.NUMERIC);
			aCol = _.sortBy(aCol, 'y');
			iCurrent2 = 0;
			iLen2 = aCol.length;
			while (iCurrent2 < iLen2) {
				vgroupTmp = SubFrameIn.getVGroup(aCol, iCurrent2);
				iCurrent2 += vgroupTmp.iCnt;
				SubFrameIn.aVGroups.push(vgroupTmp);
			}
		}
	}
	private static getCol(aGroups: any[], iStart: number) {
		var hgroupTmp: HGroup;
		var hgroupTmp2: HGroup;
		var aModResult: any[];
		var i: number, j: number;
		var nXDif: number;
		if (aGroups.length <= iStart) {
			// return null;
		}
		hgroupTmp = new HGroup(aGroups[iStart]);
		j = 1;
		for (i = iStart + 1; i < aGroups.length; i++) {
			hgroupTmp2 = new HGroup(aGroups[i]);
			nXDif = hgroupTmp2.x - hgroupTmp.x;
			if (nXDif < Global.nModAbstTol && nXDif > -Global.nModAbstTol) {
				j++;
				//valid
			} else {
				break;
			}
		}
		aModResult = new Array(j);
		for (i = 0; i < j; i++) {
			aModResult[i] = aGroups[i + iStart];
		}
		return aModResult;
	}

	//get vertical group
	private static getVGroup(aGroups: any[], iStart: number) {
		var hgroupTmp: HGroup;
		var hgroupTmp2: HGroup;
		var vgroupResult: VGroup;
		var i: number, j: number;
		var nYDif: number;
		if (aGroups.length <= iStart) {
			// return null;
		}
		hgroupTmp = new HGroup(aGroups[iStart]);
		j = 1;
		for (i = iStart + 1; i < aGroups.length; i++) {
			hgroupTmp2 = new HGroup(aGroups[i]);
			nYDif = hgroupTmp2.y - (hgroupTmp.y + hgroupTmp.height + Sol50.nVertikalAbstand);
			if (nYDif < Global.nModAbstTol && nYDif > -Global.nModAbstTol && hgroupTmp2.width == hgroupTmp.width) {
				j++;
				hgroupTmp = hgroupTmp2;
			} else {
				break;
			}
		}
		hgroupTmp = new HGroup(aGroups[iStart]);
		vgroupResult = new VGroup(null);
		vgroupResult.iCnt = j;
		vgroupResult.iCol = hgroupTmp.iCnt;
		vgroupResult.nModWith = hgroupTmp.nModWith;
		vgroupResult.height = ((hgroupTmp.height + Sol50.nVertikalAbstand) * j) - Sol50.nVertikalAbstand;//hgroupTmp.height;
		//mit Vertikalabschlussblende
		vgroupResult.height += Sol50.nVertikalAbschluss;
		vgroupResult.width = hgroupTmp.width;
		vgroupResult.x = hgroupTmp.x;
		vgroupResult.y = hgroupTmp.y;
		//mit Vertikalabschlussblende
		vgroupResult.y -= (Sol50.nVertikalAbschluss / 2);
		return vgroupResult;
	}

	//Eindeckblech zeichnen
	public static drawEindeckblech(): void {
		var i: number;
		var vgroupTmp: VGroup;
		var nY: number;
		var nX: number;
		var nHeight: number;
		for (i = 0; i < SubFrameIn.aVGroups.length; i++) {
			vgroupTmp = SubFrameIn.aVGroups[i];
			nHeight = vgroupTmp.height + Sol50Integrated.nEindeckblechZusatz;
			//Left
			nX = vgroupTmp.x - Sol50Integrated.nRandLeft;
			nY = vgroupTmp.y - (Sol50Integrated.nEindeckblechZusatz / 2);
			var rect1: any = new Konva.Rect({
				width: Sol50Integrated.nEindeckblechQS,
				height: nHeight,
				fill: Sol50Integrated.uiEindeckblechCol,
				x: nX,
				y: nY,
			});
			DrawRoofForPanel.subframeGroup.add(rect1);
			rect1.draw();

			//Right
			nX = ((vgroupTmp.x + vgroupTmp.width) - Sol50Integrated.nEindeckblechQS) + Sol50Integrated.nRandRight;
			nY = vgroupTmp.y - (Sol50Integrated.nEindeckblechZusatz / 2);
			var rect2: any = new Konva.Rect({
				width: Sol50Integrated.nEindeckblechQS,
				height: nHeight,
				fill: Sol50Integrated.uiEindeckblechCol,
				x: nX,
				y: nY,
			});
			DrawRoofForPanel.subframeGroup.add(rect2);
			rect2.draw();
		}
	}

	//Oberes Abschlussblech zeichnen
	public static drawTopAbschlussblech(): void {
		var i: number;
		var vgroupTmp: VGroup;
		var nY: number;
		var nX: number;
		var nWidth: number;
		for (i = 0; i < SubFrameIn.aVGroups.length; i++) {
			vgroupTmp = SubFrameIn.aVGroups[i];
			nX = vgroupTmp.x - (Sol50Integrated.nTopAbschlussblechZusatz / 2);
			nY = vgroupTmp.y - Sol50Integrated.nRandTop;
			nWidth = vgroupTmp.width + Sol50Integrated.nTopAbschlussblechZusatz;
			var rect: any = new Konva.Rect({
				width: nWidth,
				height: Sol50Integrated.nTopAbschlussblechQS,
				fill: Sol50Integrated.uiTopAbschlussblechCol,
				x: nX,
				y: nY,
			});
			DrawRoofForPanel.subframeGroup.add(rect);
			rect.draw();
		}
	}

	//Horizontalprofil zeichnen
	public static drawHProfil(): void {
		var i: number, j: number;
		var vgroupTmp: VGroup;
		var nModHeight: number;
		var nY: number;
		var nHalfProfHeight: number;
		nHalfProfHeight = (Sol50.nVertikalAbstand + Sol50Integrated.nHProfilHeight) / 2;
		for (i = 0; i < SubFrameIn.aVGroups.length; i++) {
			vgroupTmp = SubFrameIn.aVGroups[i];
			if (SC_Input.nModWidth / 10 == vgroupTmp.nModWith) {
				nModHeight = SC_Input.nModHeight / 10;
			} else {
				nModHeight = SC_Input.nModWidth / 10;
			}
			for (j = 0; j < vgroupTmp.iCnt; j++) {
				nY = vgroupTmp.y + (j * (nModHeight + Sol50.nVertikalAbstand));
				var rect: any = new Konva.Rect({
					width: vgroupTmp.width,
					height: Sol50Integrated.nHProfilHeight,
					fill: Sol50Integrated.uiHProfilCol,
					x: vgroupTmp.x,
					y: nY,
				});
				DrawRoofForPanel.subframeGroup.add(rect);
				rect.draw();
				// if (MountingSystem.bMarkers) {
				// 	MountingSystem.markHLine(vgroupTmp.x, vgroupTmp.x + vgroupTmp.width, nY + nHalfProfHeight, Sol50Integrated.nHProfilLen);
				// }
			}
			//bottom
			nY = vgroupTmp.y + (j * (nModHeight + Sol50.nVertikalAbstand));
			var rect: any = new Konva.Rect({
				width: vgroupTmp.width,
				height: Sol50Integrated.nHProfilHeight,
				fill: Sol50Integrated.uiHProfilCol,
				x: vgroupTmp.x,
				y: nY,
			});
			DrawRoofForPanel.subframeGroup.add(rect);
			rect.draw();
			// if (MountingSystem.bMarkers) {
			// 	MountingSystem.markHLine(vgroupTmp.x, vgroupTmp.x + vgroupTmp.width, nY + nHalfProfHeight, Sol50Integrated.nHProfilLen);
			// }
		}
	}

	//Variable
	public static sHProfilVar: string;
	//get amount
	public static getHProfil(): number {
		var i: number;
		var vgroupTmp: VGroup;
		var iResult: number = 0;
		var nTotLen: number;
		for (i = 0; i < SubFrameIn.aVGroups.length; i++) {
			vgroupTmp = SubFrameIn.aVGroups[i];
			nTotLen = (vgroupTmp.iCnt + 1) * vgroupTmp.width;
			// Horizontalprofil - Praxis - Korrektur - Faktor
			nTotLen += nTotLen * Dyn.HP_PR_CO_FA;
			iResult += Math.ceil(nTotLen / Sol50Integrated.nHProfilLen);
		}
		return iResult;
	}

	//get amount
	public static getAbschSteck(): number {
		var i: number;
		var vgroupTmp: VGroup;
		var iResult: number = 0;
		var nTotLen: number;
		for (i = 0; i < SubFrameIn.aVGroups.length; i++) {
			vgroupTmp = SubFrameIn.aVGroups[i];
			nTotLen = vgroupTmp.width * 2;
			//Horizontalprofil-Praxis-Korrektur-Faktor
			nTotLen += nTotLen * Dyn.HP_PR_CO_FA;
			iResult += Math.ceil(nTotLen / Sol50Integrated.nAbschSteckLen);
		}
		return iResult;
	}

	public static getSAMTrapez2m(): number {
		var i: number;
		var vgroupTmp: VGroup;
		var iResult: number = 0;
		var nTraProHeight: number;
		for (i = 0; i < SubFrameIn.aVGroups.length; i++) {
			vgroupTmp = SubFrameIn.aVGroups[i];
			nTraProHeight = Sol50Integrated.TraPro_calcHeight(vgroupTmp.height);
			if ((nTraProHeight / 185) - Math.floor(nTraProHeight / 185) >= 0.5) {
				iResult += Math.ceil(nTraProHeight / 185) * Math.ceil(vgroupTmp.width / 110);
			} else {
				iResult += Math.floor(nTraProHeight / 185) * Math.ceil(vgroupTmp.width / 110);
			}
		}
		return iResult;
	}
	public static getSAMTrapez1m(): number {
		var i: number;
		var vgroupTmp: VGroup;
		var iResult: number = 0;
		var nTraProHeight: number;
		for (i = 0; i < SubFrameIn.aVGroups.length; i++) {
			vgroupTmp = SubFrameIn.aVGroups[i];
			nTraProHeight = Sol50Integrated.TraPro_calcHeight(vgroupTmp.height);
			if ((nTraProHeight / 185) - Math.floor(nTraProHeight / 185) <= 0.5) {
				iResult += Math.ceil(vgroupTmp.width / 110);
			}
		}
		return iResult;
	}
	public static getProfueller18160(): number {
		var i: number;
		var vgroupTmp: VGroup;
		var iResult: number = 0;
		for (i = 0; i < SubFrameIn.aVGroups.length; i++) {
			vgroupTmp = SubFrameIn.aVGroups[i];
			iResult += Math.ceil(vgroupTmp.width / 110);
		}
		return iResult;
	}

	public static getDichtband5_6(): number {
		var i: number;
		var vgroupTmp: VGroup;
		var iResult: number = 0;
		var nLen: number;
		for (i = 0; i < SubFrameIn.aVGroups.length; i++) {
			vgroupTmp = SubFrameIn.aVGroups[i];
			nLen = (vgroupTmp.height * 2) + vgroupTmp.width;
			iResult += Math.ceil(nLen / Sol50Integrated.nDichtband5_6VPE);
		}
		return iResult;
	}

	public static getKehlDS(): number {
		var i: number;
		var vgroupTmp: VGroup;
		var iResult: number = 0;
		for (i = 0; i < SubFrameIn.aVGroups.length; i++) {
			vgroupTmp = SubFrameIn.aVGroups[i];
			iResult += Math.ceil(vgroupTmp.height / 100) * 2 + Math.ceil(vgroupTmp.width / 100);
		}
		return iResult;
	}
	public static getEindeckblech(): number {
		var i: number;
		var vgroupTmp: VGroup;
		var iResult: number = 0;
		for (i = 0; i < SubFrameIn.aVGroups.length; i++) {
			vgroupTmp = SubFrameIn.aVGroups[i];
			iResult += Math.ceil(((vgroupTmp.height + 30) / 185) * 2);
		}
		return iResult;
	}

	public static getAbschBlech(): number {
		var i: number;
		var vgroupTmp: VGroup;
		var iResult: number = 0;
		for (i = 0; i < SubFrameIn.aVGroups.length; i++) {
			vgroupTmp = SubFrameIn.aVGroups[i];
			iResult += Math.ceil((vgroupTmp.height / 185) * 2);
		}
		return iResult;
	}

	public static getTraufLuftProf(): number {
		var i: number;
		var vgroupTmp: VGroup;
		var iResult: number = 0;
		for (i = 0; i < SubFrameIn.aVGroups.length; i++) {
			vgroupTmp = SubFrameIn.aVGroups[i];
			iResult += Math.ceil(vgroupTmp.width / 200);
		}
		return iResult;
	}

	public static getHAbschKapES(): number {
		var i: number;
		var vgroupTmp: VGroup;
		var iResult: number = 0;
		for (i = 0; i < SubFrameIn.aVGroups.length; i++) {
			vgroupTmp = SubFrameIn.aVGroups[i];
			iResult += Math.ceil(((vgroupTmp.iCnt + 1) / 10) * 2);
		}
		return iResult;
	}

	public static getEdelBohr(): number {
		var i: number;
		var vgroupTmp: VGroup;
		var iResult: number = 0;
		for (i = 0; i < SubFrameIn.aVGroups.length; i++) {
			vgroupTmp = SubFrameIn.aVGroups[i];
			iResult += Math.ceil((((vgroupTmp.width / 35) * (vgroupTmp.iCnt + 1)) * 2) / 50);
		}
		return iResult;
	}

	public static getVDichtS(): number {
		var i: number;
		var vgroupTmp: VGroup;
		var iResult: number = 0;
		for (i = 0; i < SubFrameIn.aVGroups.length; i++) {
			vgroupTmp = SubFrameIn.aVGroups[i];
			iResult += Math.ceil((vgroupTmp.height * (vgroupTmp.iCol - 1)) / 100);
		}
		return iResult;
	}

	static getKabFanNetAndBohrSchrString(): RoofItemType[] {
		var sRet: RoofItemType[] = [];
		var iKabFanNetCnt: number;
		var iBohrVA6322Cnt: number;
		var sBohrVA6322Var: string;
		var iBohrSchrCnt: number;
		var sSeperator: string;
		sBohrVA6322Var = Sol50Integrated.sBohrSchrVar;
		if (Sol50Integrated.sKabFanNetVar == "") {
			iKabFanNetCnt = 0;
		} else {
			iKabFanNetCnt = SubFrameIn.getKabFanNet();
		}
		iBohrVA6322Cnt = iKabFanNetCnt * 20;
		Sol50Integrated.iKabFanNetBS = iBohrVA6322Cnt;
		iBohrSchrCnt = SubFrameIn.getBohrSchr();
		if (sBohrVA6322Var == Sol50Integrated.sBohrSchrVar) {
			iBohrVA6322Cnt += iBohrSchrCnt;
			iBohrVA6322Cnt = Math.ceil(iBohrVA6322Cnt / Sol50Integrated.nBohrSchrVPE);
			iBohrSchrCnt = 0;
		} else {
			iBohrVA6322Cnt = Math.ceil(iBohrVA6322Cnt / Sol50Integrated.nBohrSchrVPE);
			iBohrSchrCnt = Math.ceil(iBohrSchrCnt / Sol50Integrated.nBohrSchrVPE);
		}
		if (iKabFanNetCnt > 0) {
			sRet.push(new RoofItemType(NaN, Sol50Integrated.sKabFanNetVar, iKabFanNetCnt));
		}
		if (iBohrVA6322Cnt > 0) {
			sRet.push(new RoofItemType(NaN, sBohrVA6322Var, iBohrVA6322Cnt));
		}
		if (iBohrSchrCnt > 0) {
			sRet.push(new RoofItemType(NaN, Sol50Integrated.sBohrSchrVar, iBohrSchrCnt));
		}
		return sRet;
	}

	public static getKabFanNet(): number {
		var i: number;
		var vgroupTmp: VGroup;
		var iResult: number = 0;
		for (i = 0; i < SubFrameIn.aVGroups.length; i++) {
			vgroupTmp = SubFrameIn.aVGroups[i];
			iResult += Math.ceil((vgroupTmp.width * vgroupTmp.iCnt) / 1400);
		}
		return iResult;
	}

	public static getBohrSchr(): number {
		var i: number;
		var vgroupTmp: VGroup;
		var iResult: number = 0;
		if (Sol50Integrated.sBohrSchrVar == "") {
			return 0;
		}
		for (i = 0; i < SubFrameIn.aVGroups.length; i++) {
			vgroupTmp = SubFrameIn.aVGroups[i];
			iResult += ((vgroupTmp.width * (vgroupTmp.iCnt + 1)) / 35) * 2;
		}
		return iResult;
	}

	public static getBitBandAlu10m(): number {
		var i: number;
		var vgroupTmp: VGroup;
		var iResult: number = 0;
		var nHPLen: number;
		var nPieceCnt: number;
		nPieceCnt = 0;
		for (i = 0; i < SubFrameIn.aVGroups.length; i++) {
			vgroupTmp = SubFrameIn.aVGroups[i];
			nHPLen = vgroupTmp.width * (vgroupTmp.iCnt + 1);
			nPieceCnt += Math.ceil(nHPLen / 20);
		}
		//für Kabelnetz-Bohrschrauben
		nPieceCnt += Sol50Integrated.iKabFanNetBS;
		iResult = Math.ceil((nPieceCnt * 3.5) / 1000);
		return iResult;
	}

	public static getErdbausatz(): number {
		return SubFrameIn.aVGroups.length;
	}

	public static getTopAbschlussblech(): number {
		var i: number;
		var vgroupTmp: VGroup;
		var iResult: number = 0;
		for (i = 0; i < SubFrameIn.aVGroups.length; i++) {
			vgroupTmp = SubFrameIn.aVGroups[i];
			iResult += Math.ceil((vgroupTmp.width - 15) / 185);
		}
		return iResult;
	}

	public static getLuKam(): number {
		var i: number;
		var vgroupTmp: VGroup;
		var iResult: number = 0;
		for (i = 0; i < SubFrameIn.aVGroups.length; i++) {
			vgroupTmp = SubFrameIn.aVGroups[i];
			iResult += Math.ceil(vgroupTmp.width / Sol50Integrated.nLuKamVPE);
		}
		return iResult;
	}

	public static getAnKleBan(): number {
		var i: number;
		var vgroupTmp: VGroup;
		var iResult: number = 0;
		for (i = 0; i < SubFrameIn.aVGroups.length; i++) {
			vgroupTmp = SubFrameIn.aVGroups[i];
			//100 cm for margin
			iResult += Math.ceil((vgroupTmp.width + 100) / Sol50Integrated.nAnKleBanVPE);
		}
		return iResult;
	}

	public static getDichtband(): number {
		var i: number;
		var vgroupTmp: VGroup;
		var iResult: number = 0;
		var nThreePercent: number;
		var iDichtBandReihen: number;
		var nTraProHeight: number;
		for (i = 0; i < SubFrameIn.aVGroups.length; i++) {
			vgroupTmp = SubFrameIn.aVGroups[i];
			nTraProHeight = Sol50Integrated.TraPro_calcHeight(vgroupTmp.height);
			nThreePercent = vgroupTmp.width * 0.03;
			//TODO: Reihen wegen 1m und 2m überprüfen
			iDichtBandReihen = Math.floor(nTraProHeight / 185);
			iResult += Math.ceil((iDichtBandReihen * (vgroupTmp.width + nThreePercent)) / Sol50Integrated.nDichtbandVPE);
		}
		return iResult;
	}

	public static getEckAns(): number {
		var i: number;
		var vgroupTmp: VGroup;
		var iResult: number = 0;
		for (i = 0; i < SubFrameIn.aVGroups.length; i++) {
			iResult += 1;
		}
		return iResult;
	}

	public static getHafKleHal(): number {
		var i: number;
		var vgroupTmp: VGroup;
		var iResult: number = 0;
		iResult += Math.ceil((SubFrameIn.getTopAbschlussblech() * 3 + SubFrameIn.getEindeckblech() * 4 + 4) / Sol50Integrated.nHafKleHalVPE);
		return iResult;
	}

	public static getDistAdap(): number {
		var i: number;
		var hgroupTmp: HGroup;
		var iResult: number = 0;
		for (i = 0; i < Global.hgroups.length; i++) {
			hgroupTmp = new HGroup(Global.hgroups[i]);
			iResult += (hgroupTmp.iCnt * 2) + 2;
		}
		iResult = Math.ceil(iResult / Sol50Integrated.nDistAdapVPE);
		return iResult;
	}

	public static getSOLGuard(): number {
		var i: number;
		var vgroupTmp: VGroup;
		var iResult: number = 0;
		for (i = 0; i < SubFrameIn.aVGroups.length; i++) {
			vgroupTmp = SubFrameIn.aVGroups[i];
			iResult += (vgroupTmp.iCol + 1) * vgroupTmp.iCnt;
		}
		return iResult;
	}

	static compareObjects(object1 :any, object2:any) {
		const obj1 = object1['x']
		const obj2 = object2['x']
	  
		if (obj1 < obj2) {
		  return -1
		}
		if (obj1 > obj2) {
		  return 1
		}
		return 0
	  }

}